export const UpdateLauncherModal = ({totalBytes, downloadedBytes, progress}) => {
    return (<div className={"flex flex-col w-full"}>
        <div className="relative w-full bg-gray-300 rounded h-4">
            <div className="absolute h-full bg-blue-600 rounded"
                 style={{width: `${(parseInt(downloadedBytes) / parseInt(totalBytes) * 100)}%`}}></div>
            {/* Adjust width dynamically */}
        </div>

        <div className={"flex justify-between mt-2 text-sm"}>
            <div>
                { parseInt((totalBytes / 1000000).toString()) } MB de { parseInt((downloadedBytes / 1000000).toString()) } MB baixados
            </div>
            <div>
                {progress}%
            </div>
        </div>

        <div className={"flex bg-red-200 mt-5 px-2 py-2 rounded-md"}>
            Atenção: não feche o launcher enquanto a atualização estiver em andamento.
        </div>
    </div>);
};